import React from 'react';
import { get } from 'lodash';
import { FinanceResponseData } from '@upstart/harmony/lib/legos/financingTypes';
import { StringInputType } from '../ricFormTypes';
import { SectionStringInputItem } from '../Components';

const SchemaStringInput = ({
  formElement,
  responseData,
  fetchResponseWithUpdatedData,
}: {
  formElement: StringInputType;
  responseData: FinanceResponseData;
  fetchResponseWithUpdatedData: (data: Partial<FinanceResponseData>) => void;
}) => {
  const { title, subtitle, responseDataField, required } = formElement;

  const value = get(responseData, responseDataField)?.toString();
  return (
    <SectionStringInputItem
      title={title}
      subtitle={subtitle}
      value={value}
      field={responseDataField}
      onChange={fetchResponseWithUpdatedData}
      required={required}
    />
  );
};

export default SchemaStringInput;
